<template>
    <div>
        <!-- <p v-if="error" class="text-danger">{{ errorMsg }}</p> -->

        <b-alert v-model="error" dismissible fade variant="danger">
            {{ errorMsg }}
        </b-alert>

        <div class="">
            <b-alert :show="refsErrorMsgArray.length > 0" fade variant="danger">
                <ul class="max-width-400 text-danger mb-0">
                    <li v-for="errMsg in refsErrorMsgArray" :key="errMsg">{{ errMsg }}</li>
                </ul>
            </b-alert>
        </div>
        <div class="p-3 mb-4 border rounded bg-gray-50 shadow-sm">

            <b-overlay :show="saving" rounded="sm">
            <div class="row">
                <div class="col-3">
                    <h5 class="mb-3">Basic Information</h5>
                    <div class="text-muted pl-2">
                        <span class="text-danger">*</span>
                        <span> = required</span>
                    </div>
                </div>
                <div class="col-9">
                    <div class="row mb-3">
                        <div class="col">
                            <hot-edit-input
                                label="Title"
                                size="lg"
                                required
                                ref="title"
                                v-model="rfxData.title"
                                :edit-mode="localEditMode"
                                class=""
                                label-vertical
                                :loading="loading"
                                :disabled="allDisabled"
                            ></hot-edit-input>
                        </div>
                    </div>
                    
                    <b-row align-h="between" class="mb-3">
                        <b-col cols="auto" class="flex-fill">
                            <hot-edit-select
                                label="Event Type"
                                required
                                ref="type"
                                v-model="rfxData.rfx_type"
                                :edit-mode="localEditMode"
                                :options="rfxData.rfx_type_options"
                                blank-option="-- N/A --"
                                label-vertical
                                :loading="loading"
                                :disabled="allDisabled"
                            ></hot-edit-select>
                        </b-col>
                        <b-col cols="auto" class="flex-fill">
                            <hot-edit-select
                                label="Category"
                                ref="category"
                                v-model="rfxData.sourcing_category"
                                :edit-mode="localEditMode"
                                :options="rfxData.sourcing_category_options"
                                blank-option="-- none --"
                                label-vertical
                                :loading="loading"
                                :disabled="allDisabled"
                            ></hot-edit-select>
                        </b-col>
                        <b-col cols="auto" class="flex-fill">
                            <hot-edit-switch
                                label="Confidential?"
                                popover-content="If enabled, this will show 'CONFIDENTIAL' on the RFx page for suppliers."
                                v-model="rfxData.is_confidential"
                                switch-size="lg"
                                label-vertical
                                :edit-mode="localEditMode"
                                :loading="loading"
                                :disabled="allDisabled"
                            ></hot-edit-switch>
                        </b-col>
                    </b-row>
                    <div class="row mb-3">
                        <div class="col">
                            <hot-edit-select
                                label="Event Owner"
                                required
                                ref="owner"
                                v-model="rfxData.sourcing_owner"
                                :edit-mode="localEditMode"
                                :options="rfxData.sourcing_owner_options"
                                label-vertical
                                :loading="loading"
                                :disabled="allDisabled"
                            ></hot-edit-select>  <!-- @input="handleDataChange" -->
                        </div>
                        <div class="col">
                            <hot-edit-switch
                                label="Show Contact Info?"
                                popover-content="If enabled, this will show your real email address on the supplier-facing event page.  If not enabled, it will use an email alias and forward all emails to you."
                                v-model="rfxData.show_real_owner_email"
                                switch-size="lg"
                                label-vertical
                                :edit-mode="localEditMode"
                                :loading="loading"
                                :disabled="allDisabled"
                            ></hot-edit-switch>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <sourcing-tags-multiselect
                                label="Sourcing Tags"
                                v-model="rfxData.sourcing_tags"
                                :loading="loading"
                                :disabled="allDisabled"
                            ></sourcing-tags-multiselect>
                        </div>
                    </div>
                </div>
            </div>
            </b-overlay>
        </div>

        <div v-if="splTagsEnabled" class="p-3 mb-4 border rounded bg-gray-50 shadow-sm">
            <b-overlay :show="saving" rounded="sm">
            <div class="row">
                <div class="col-3">
                    <h5 class="mb-3">Additional Tags &amp; Categories</h5>
                    <!-- <div class="text-muted pl-2">
                        <span class="text-danger">*</span>
                        <span> = required</span>
                    </div> -->
                </div>
                <div class="col-9">
                    <div class="row">
                        <div class="col">
                            <TagFields
                                v-model="splTaggings"
                                :config="splTaggingConfig"
                                :isEditing="localEditMode"
                                class="w-100"
                            ></TagFields>
                        </div>
                    </div>
                    <!-- <pre>{{ splTaggings }}</pre> -->
                </div>
            </div>
            </b-overlay>
        </div>

        <div class="p-3 mb-4 border rounded bg-gray-50 shadow-sm">
            <b-overlay :show="saving" rounded="sm">
            <div class="row">
                <div class="col-3">
                    <h5 class="mb-2">Response Deadline</h5>
                    <p class="text-muted font-size-80 text-uppercase">Optional</p>
                    <div class="text-muted">
                        <p>If provided, the Status will <em>automatically</em> change from <b>OPEN</b> to <b>CLOSED</b> on this date, unless you close it manually earlier.</p>
                        <!-- <p>The event will automatically open/close based on these dates.</p>
                        <p>All dates are optional.</p>
                        <p>You can always manually override the opening/closing of the event.</p> -->
                    </div>
                    <ul class="text-danger small list-unstyled">
                        <li v-if="questionCloseError" class="mb-2">{{questionCloseError}}</li>
                        <li v-if="startCloseError" class="mb-2">{{startCloseError}}</li>
                    </ul>
                </div>
                <div class="col-9">
                    <transition name="fade-fast" mode="out-in">
                    <div v-if="!rfxData.disable_auto_dates" class="my-3 d-flex justify-content-around align-items-start">
                        <div class="width-300">
                            <hot-edit-date-time
                                label="Response Deadline"
                                ref="closeDate"
                                popover-content="This is the deadline for accepting responses.  If set, the event status will automatically be changed to 'Review' on this date.  Optional."
                                v-model="rfxData.close_date_planned"
                                :edit-mode="localEditMode"
                                label-vertical
                                default-time="17:00:00"
                                :loading="loading"
                                :disabled="allDisabled || !canSetCloseDate"
                                class="w-100 mb-3"
                            ></hot-edit-date-time>
                            <div v-if="!canSetCloseDate && rfxData.state_dict" class="small text-muted mb-2">
                                <span class="font-weight-bold text-danger">NOTE: </span>
                                Close Date can only be set while event is OPEN or DRAFT.  (Currently is: {{ rfxData.state_dict.title }}).
                            </div>
                            <div class="text-muted small">
                                If Response Deadline is not set, you can control the status manually from the 
                                <b-link :href="rfxData.event_dashboard_url">Event Dashboard.</b-link>
                            </div>
                        </div>
                        <div class="width-350">
                            <hot-edit-switch
                                label="Allow revisions after submission?"
                                description="If enabled, suppliers can make changes to their responses after they submit (unlocked).  Recommended."
                                popover-content="If enabled, suppliers can make changes to their responses after they submit (unlocked).  Recommended.  You can lock all responses at once from the Event Dashboard."
                                v-model="rfxData.allow_late_modify"
                                switch-size="lg"
                                label-cols="auto"
                                :loading="loading"
                                :disabled="allDisabled"
                                :edit-mode="localEditMode"
                                class="mb-3"
                            ></hot-edit-switch>
                            <hot-edit-switch
                                label="Allow late responses?"
                                description="If enabled, Response Deadline is still shown to suppliers, but is a 'soft' deadline - outstanding invites or unsubmitted responses will not be automatically cancelled."
                                popover-content="If enabled, Response Deadline is still shown to suppliers, but is a 'soft' deadline - outstanding invites or unsubmitted responses will not be automatically cancelled."
                                v-model="rfxData.allow_late_responses"
                                switch-size="lg"
                                label-cols="auto"
                                :loading="loading"
                                :disabled="allDisabled"
                                :edit-mode="localEditMode"
                            ></hot-edit-switch>
                        </div>
                    </div>
                    </transition>
                </div>
            </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>
import { suppliosApi } from '../js/api-service';
import { tenantInfoMixin } from '@/js/custom-vue-mixins';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import { 
    isEqualAnyOrder, 
    toLuxonDateTime, 
} from '../js/filters-helpers';
import { 
    HotEditInput,
    HotEditSelect,
    HotEditDateTime,
    HotEditSwitch,
} from '../js/custom-form-components';
import TagFields from '@/components/taxonomy/taggings/TagFields.vue';

export default {
    name: 'RfxSetupConfig',
    components: {
        HotEditInput,
        HotEditSelect,
        HotEditDateTime,
        HotEditSwitch,
        TagFields,
    },
    mixins: [tenantInfoMixin],
    props: {
        rfxPk: {
            type: [Number, String],
            required: true,
        },
        isReadOnly: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            saving: false,
            rfxDataFetchCount: 0,  // use this to track if our getRfxData was first time or not
            rfxData: {},  // main data object
            rfxDataLastSaved: {},  // stash here when you first get data and when you save
            splTaggings: {},  // object with keys being field, values being array of taggings, pulled out from rfxData, or side-loaded
            splTaggingsLastSavedCombinedIds: [],  // an array of ${field.id}-${tag.id} for each tag in splTaggings, used to compare if tags changed
            localEditMode: true,
            // validators
            random_price: null,
            random_price_currency: 'USD',
            refsErrorMsgArray: [],  // array of error message strings, set by checkRefsValid() method
            validators: {
                startClose: '',
                questionClose:  'Question Close Date must be later than Start Date, before Close Date',
            },  // object holding messages of invalid things in dates
            fieldsToUpdate: [  // array of field names that we will watch and send update to API if changed
                'title',
                'rfx_type',
                'sourcing_owner',  // was 'sourcing_owner' before Nov 21 2021
                'show_real_owner_email',
                'is_confidential',
                'close_date_planned',
                'allow_late_responses',
                'allow_late_modify',
                'question_close_date',
                'open_date_planned',
                'disable_auto_dates',
                // do not update sm_state here - use separate component and/or transition methods
                'spend_baseline',
                'spend_target',
                'sourcing_category',  // 'sourcing_category' before Nov 21 2021
                'sourcing_tags',
            ],
            refsForValidation: [  // these are the form inputs that you want to check for validation, component must have .checkInvalidMessage() method on it
                'title',
                'type',
                'category',
                'owner',
                //'startDate',
                //'questionCloseDate',
                'closeDate',
            ],  // this is all possible refs, then you will filter out ones that aren't visible before actually checking
        }
    },
    computed: {
        hasRfxData: function() {  // make sure its not empty, and that it has an id
            return !isEmpty(this.rfxData) && !!this.rfxData.id;
        },
        allDisabled() {
            // return Boolean (True) to disable all inputs
            // used when we're in Archived mode, etc.
            // NEW NOV 9 2022 - also set this if RfxTenantUser is not admin (now allowing decision team to see it in some cases)
            return this.isReadOnly || (this.rfxData.sm_state === 'archived');
        },
        currentRfxDataNormalized: function() {  // current rfxData in format that we'll post to API, used for checking for unsaved changes
            return this.normalizeDataForSave(this.rfxData);
        },
        hasUnsavedChanges: function() {
            // compare currentRfxDataNormalized to rfxDataLastSaved (which was already run through normalizer function)
            // especially have to normalize DateTimes because of slight differences in string formats from DRF and from Luxon (including milliseconds or not): string -> Luxon DateTime -> string
            // all normalization was moved to method below
            //return !isEqual(this.currentRfxDataNormalized, this.rfxDataLastSaved);
            // MUST CHECK IF WE LOADED DATA FROM API YET... USE rfxDataFetchCount -- IF rfxDataFetchCount === 0, THEN WE HAVEN'T LOADED INITIAL DATA YET, JUST SAY NO UNCHANGED DATA YET
            if (this.rfxDataFetchCount === 0) {
                return false;
            }
            const splTagsAreSame = isEqualAnyOrder(this.getSplTaggingsCombinedIds(this.splTaggings), this.splTaggingsLastSavedCombinedIds);
            return !splTagsAreSame || !isEqualAnyOrder(this.currentRfxDataNormalized, this.rfxDataLastSaved);  // our own version of isEqual using isEqualWith with customizer function to ignore order of arrays
        },
        // ======= VALIDATORS ==========
        startCloseError: function() {  // return '' empty string if all is OK, if error return error message
            if (this.rfxData.disable_auto_dates) return '';
            if (this.rfxData.open_date_planned && this.rfxData.close_date_planned) {
                const startDate = new Date(this.rfxData.open_date_planned);
                const closeDate = new Date(this.rfxData.close_date_planned);
                return (closeDate > startDate) ? '' : 'Close Date must be later than Start Date';
            } else return '';
        },
        questionCloseError: function() {
            if (this.rfxData.disable_auto_dates) return '';
            const qcErrMsg = 'Question Close Date must be later than Start Date and before Close Date';
            let qcErr = false;
            if (this.rfxData.question_close_date) {
                const qcDate = new Date(this.rfxData.question_close_date);
                if (this.rfxData.open_date_planned) {
                    const startDate = new Date(this.rfxData.open_date_planned);
                    if (startDate > qcDate) {
                        qcErr = true;
                    }
                }
                if (this.rfxData.close_date_planned) {
                    const closeDate = new Date(this.rfxData.close_date_planned);
                    if (qcDate > closeDate) {
                        qcErr = true;
                    }
                }
            }
            return qcErr ? qcErrMsg : '';
        },
        timelineValid: function() {
            // return true if all OK.  if any Error props have strings, there is error
            let hasError = this.startCloseError || this.questionCloseError;
            return !hasError;
        },
        canSetCloseDate() {
            // since we are not using Rfx() instance here, we need to pull this out of state_dict
            // this tells us if we can allow setting a close date -- based on the current state
            // we don't allow setting it in states where auto-close won't happen -- too confusing for user
            return this.rfxData?.state_dict?.can_set_close_date_planned ?? false;
        },
        splTagsEnabled() {
            // check tenant flag for now
            // could also just have something in the rfxData object from backend that checks if this tenant has any spl tag fields on Rfx
            // but might still want a feature flag to hide it until ready
            return this.$getTenantFlag('taxonomy_rfx_tags', false);  // "taxonomy_rfx_tags" to match other similar ones
        },
        splTaggingConfig() {
            return {
                modelLabel: 'rfx.Rfx',
                objectId: this.rfxPk,
                layout: 'dropdown',
                useInternalEdit: false,
            };
        },
    },
    mounted: function() {
        this.getRfxData();
    },
    methods: {
        saveAll: function() {
            // PUBLIC METHOD TO CALL FROM PARENT
            // should handle save of all things, and return Boolean if OK to proceed to next step in wizard or not
            if (this.allDisabled) {
                return {
                    statusPromise: Promise.resolve(false),
                    successMessage: 'No changes allowed - event is archived',
                };
            }
            let returnPromise = this.saveRfxData();
            console.log('From RfxSetupConfig saveAll, return from saveRfxData is below, should be Promise resolving to Boolean');
            console.log(returnPromise);
            //return returnPromise;
            return {
                statusPromise: returnPromise,
                successMessage: 'Basic settings saved',
            };
            //return this.saveRfxData(); // returns Boolean based on whether things were valid, and if save was successful
        },
        okToContinue: function() {
            // PUBLIC METHOD CALLED FROM PARENT - takes tabChangeEvent as arg, return Promise that resolves to boolean where true = can continue
            console.log('from component starting okToContinue');
            if (!this.hasUnsavedChanges) return Promise.resolve(true);  // if no unsaved changes, return Promise that resolves to true
            // otherwise we need to show confirm modal
            let confirmMessage = 'You have unsaved changes on this page.  Are you sure you want to leave?';
            return this.$bvModal.msgBoxConfirm(confirmMessage, {
                title: 'Discard Unsaved Changes?',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Yes, Discard Changes',
                cancelTitle: 'No, Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            });  // just return this directly... will be Promise that resolves to true if click OK, false otherwise
            //return Promise.resolve(true);  // change later
        },
        showSaveSuccess: function(msg) {
            // separating out save success message toast for DRY
            let successMsg = msg ? msg : 'Basic Settings saved';
            this.$toast.success(successMsg);
        },
        // PUBLIC METHODS ABOVE, private methods below
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        handleResponseData: function(respData) {
            // NOT using Rfx() instance here -- since you're not using the matching Serializer
            // you're using an update serializer for both directions for consistency
            // const rfxInst = new Rfx(respData);  // respData here is the API response.data

            // implementing this so we have consistent way to handle on initial get and on save
            // using this in both get and save assumes the API response format is consistent for both!
            // tweak empty value for category... might be null from api, replace with empty string instead
            if (respData.sourcing_category === null) respData.sourcing_category = '';
            this.stashLastSaved(respData);
            // this.rfxData = respData;
            const { taggings_by_field, ...otherRfxData } = respData;  // destructure to pull out taggings_by_field, we'll manage that separately
            this.rfxData = otherRfxData;
            this.splTaggings = taggings_by_field;
            this.rfxDataFetchCount ++;
        },
        stashLastSaved: function(respData) {
            // pass in the full responseData from API
            // this will run through normalizer (which also clones it), then stash it on this.rfxDataLastSaved
            const { taggings_by_field, ...otherRfxData } = respData;  // destructure to pull out taggings_by_field, we'll manage that separately
            // this.rfxDataLastSaved = this.normalizeDataForSave(respData);
            this.rfxDataLastSaved = this.normalizeDataForSave(otherRfxData);
            // TODO - check this below for splTaggings - might have to normalize it so we can compare easier later
            this.splTaggingsLastSavedCombinedIds = this.getSplTaggingsCombinedIds(taggings_by_field || {});
        },
        getRfxData: function() {
            // get our initial data
            this.loading = true;
            suppliosApi.rfx.getSetupConfigData(this.rfxPk)
            .then(response => {
                console.log('got setup config data, response below');
                console.log(response);
                this.handleResponseData(response.data);
            })
            .catch(error => this.handleError(error, 'Error while getting initial data'))
            .finally(() => {
                this.loading = false;
            });
        },
        formatLocalData() {
            // use this for pull out what you need from API Data (AFTER instantiating api response with Rfx instance... which populates any fields you may be missing)
            // this should return a NEW object in the format you want data for local edits, and IDEALLY in the same format you'll send things back to API
            // why this is important?  your Rfx() instance will have nested objects (ie: sourcing_owner) but when you send things back to API, you should send back the sourcing_owner ID as 'sourcing_owner' -- serializer will expect that
            // so in here, pull out the ID from sourcing_owner.id or sourcing_owner_id and set it as sourcing_owner
            return {};
        },
        getSplTaggingsCombinedIds(splTaggings) {
            // create an array of ${field.id}-${tag.id} for each tag in splTaggings object
            const comboIds = [];
            Object.entries(splTaggings).forEach(([fieldId, tags]) => {
                tags.forEach(tag => {
                    comboIds.push(`${fieldId}-${tag.id}`);
                });
            });
            return comboIds;
        },
        normalizeDataForSave: function(dataObject) {
            // pass in the full rfx data object... this will clone it before doing anything else with it
            // this will then do 2 things: 1) pulls out only the fields you want to save and 2) normalizes it to one consistent format so you can use it for comparing old vs. new data
            // pulling out fields:  takes array of this.fieldsToUpdate and makes rfxData object with those keys only
            // normalizing -- do this for 2 reasons:
            // 1) Making sure all values (especially empty/null values!) are in the format the API wants -- ie: empty datetimes must be null instead of empty string
            // 2) Making sure all formats returned from Vue components are in same format as raw values from API (also important for datetimes)
            const fullObj = cloneDeep(dataObject);
            let preNormalized = {};
            Object.entries(fullObj).forEach(([key, value]) => {
                if (this.fieldsToUpdate.includes(key)) {
                    preNormalized[key] = value;
                }
            });  // now we have our 'smaller' object with only certain keys, but still not normalized
            const normalizer = function(theObject) {  // defining our normalizer function
                // put any logic here for fields that need to be normalized
                const dateTimeFields = ['close_date_planned', 'question_close_date', 'open_date_planned'];
                dateTimeFields.forEach(field => {
                    // NEW Nov 21 2021 - check if we already have DateTime instances... likely do in Rfx class instance
                    theObject[field] = theObject[field] ? toLuxonDateTime(theObject[field]).toISO() : null;  // this normalizes it
                    //theObject[field] = theObject[field] ? DateTime.fromISO(theObject[field]).toISO() : null;
                });
                return theObject;
            };
            // now run our normalizer and return normalized object
            return normalizer(preNormalized);
        },
        handleDataChange: function() {
            // call this on blur, then you can save after any change - HOLD - wait until you have time to do it right
            this.saveRfxData(true);
        },
        saveRfxData: function(quietMode) {
            let refsValid = this.checkRefsValid();
            if (!refsValid) return Promise.resolve(false);
            this.saving = quietMode ? false : true;
            //let saveSuccess = null;
            const updateData = cloneDeep(this.normalizeDataForSave(this.rfxData));
            const splTaggings = cloneDeep(this.splTaggings);
            // now add splTaggings to updateData, so we can send it all in one - serializer has mixin that handles it all, silently ignores things if TU doesn't have permission to change a certain tag field
            updateData.taggings_by_field = splTaggings;
            return suppliosApi.rfx.updateSetupConfigData(this.rfxPk, updateData)
            .then(response => {
                console.log('updated data via API, response below');
                console.log(response);
                this.handleResponseData(response.data);
                if (!quietMode) this.showSaveSuccess('Basic Settings saved');
                //saveSuccess = true;
                /* this.$bvToast.toast('Settings Saved', {
                    title: 'Success',
                    solid: true,
                }); */
                this.requestUpdateHeader();
                return true;  // passed to last then/finally as saveSuccess arg
            })
            .catch(error => {
                this.handleError(error, 'Error while saving data');
                return false;  // passed to last then/finally as saveSuccess arg
            })
            .then((saveSuccess) => {
                this.saving = false;
                console.log('From inside last .then() of saveRfxData in RfxSetupConfig, value of saveSuccess and refsValid:');
                console.log(saveSuccess);
                console.log(refsValid);
                return saveSuccess && refsValid;  // return Boolean for whether this was successfull or not 
                // this is last in promise chain, so it should be return value from the function, as long as you returned result of axios promise chain
            });
        },
        checkRefsValid: function() {
            // check that all refs are valid -- need to add them individually
            // each one MUST have an .isValid property on them
            const refsToCheck = this.refsForValidation;
            console.log('dumping this.$refs to see what is here');
            console.log(this.$refs);
            let errorMsgArray = [];
            refsToCheck.forEach(ref => {
                let fullRef = this.$refs[ref];
                let errorMsg = fullRef.checkInvalidMessage();  // this actually gets error messages, not just true/false
                console.log(errorMsg);
                if (errorMsg) {
                    errorMsgArray.push(errorMsg);
                }
            });
            this.refsErrorMsgArray = errorMsgArray;
            return errorMsgArray.length < 1 ? true : false;
        },
        requestUpdateHeader: function() {
            // emit event to parent, or to $root, to handle reloading header component because of changed header data
            //this.$root.reloadHeader();
            this.$root.$refs.rfxInternalHeader.refreshData(); // go directly to the ref rather than through root instance method
            //this.$root.updateHeader(newRfxData);
        }
    }
}
</script>

<style>

</style>